import { render, staticRenderFns } from "./UserSettingHolderGame.vue?vue&type=template&id=980d1c7e&scoped=true&"
import script from "./UserSettingHolderGame.vue?vue&type=script&lang=js&"
export * from "./UserSettingHolderGame.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingHolderGame.vue?vue&type=style&index=0&id=980d1c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980d1c7e",
  null
  
)

export default component.exports